import React from 'react'
import Helmet from 'react-helmet'
import { helmetJsonLdProp } from 'react-schemaorg'
import useSiteMetadata from '@helpers-blog/useSiteMetadata'
import { graphql, useStaticQuery } from "gatsby"
// import defaultImg from "../images/default-og-image.jpg"
// import { globalHistory } from "@reach/router"

const DEFAULT_OG_THUMBNAIL = "default-og-image"
//TODO: check if obsolete due to manifest plugin
const FAVICON = "favicon"

const Seo = ({
                 title,
                 description,
                 excerpt,
                 meta,
                 keywords,
                 author,
                 category,
                 date,
                 timeToRead,
                 children,
                 thumbnail,
                 siteUrl
             }) => {

     const filesQuery = useStaticQuery(
        graphql`
          {
            allFile(limit: 2, filter: {name: {in: ["favicon", "default-og-image"]}}) {
              nodes {
                publicURL
              }
            }
          }
        `
    )
    const staticFileUrls = new Map()
    if(filesQuery && filesQuery.allFile && filesQuery.allFile.nodes){
        filesQuery.allFile.nodes.forEach(file => {
            const fileUrl = file.publicURL
            if (fileUrl.includes(FAVICON)) {
                staticFileUrls.set(FAVICON, fileUrl)
            } else if (fileUrl.includes(DEFAULT_OG_THUMBNAIL)) {
                staticFileUrls.set(DEFAULT_OG_THUMBNAIL, fileUrl)
            }
        })
    }

    const site = useSiteMetadata()

    const social = (author && author.social) || site.social || []
    const twitter =
        social.find(s => s.name && s.name.toLowerCase() === 'twitter') || {}

    description = excerpt || description || site.description

    thumbnail = thumbnail && thumbnail.hero && thumbnail.hero.src
    let thumbnailUrl =
        thumbnail &&
        (thumbnail.startsWith('//')
            ? thumbnail
            : siteUrl && `${siteUrl}${thumbnail}`)
    thumbnailUrl = thumbnailUrl ? thumbnailUrl : staticFileUrls.get(DEFAULT_OG_THUMBNAIL)

    /**
     * Meta Tags
     */

    const metaTags = [
        { itemprop: 'name', content: title || site.title },
        { itemprop: 'description', content: description },
        { name: 'description', content: description },

        { property: 'og:title', content: title || site.title },
        { property: 'og:description', content: description },
        { property: 'og:type', content: 'website' },
        { property: 'og:site_name', content: site.name },
        { property: 'og:image', content: thumbnailUrl },

        { name: 'twitter:card', content: 'summary' },
        { name: 'twitter:site', content: site.name },
        { name: 'twitter:title', content: title },
        { name: 'twitter:description', content: description },
        { name: 'twitter:creator', content: twitter.url }
    ]

    if (keywords && keywords.length > 0) {
        metaTags.push({ name: 'keywords', content: keywords.join(', ') })
    }

    if (date) {
        metaTags.push({ name: 'article:published_time', content: date })
    }

    if (timeToRead) {
        metaTags.push({ name: 'twitter:label1', value: 'Reading time' })
        metaTags.push({
            name: 'twitter:data1',
            value: `${timeToRead} min read`
        })
    }

    if (meta) {
        metaTags.push(meta)
    }

    /**
     * Structured Data (JSON-LD)
     */

    const scripts = []

    // Article
    if (title && author) {
        const articleJsonLd = helmetJsonLdProp({
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: title,
            image: thumbnailUrl,
            datePublished: date
        })
        scripts.push(articleJsonLd)
    }

    // Breadcrumb
    if (title && category) {
        const breadcrumbJsonLd = helmetJsonLdProp({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
                {
                    '@type': 'ListItem',
                    position: 1,
                    name: site.name,
                    item: siteUrl
                },
                {
                    '@type': 'ListItem',
                    position: 2,
                    name: category.name,
                    item: `${siteUrl}${category.slug}`
                }
            ]
        })
        scripts.push(breadcrumbJsonLd)
    }

    return (
        <Helmet
            htmlAttributes={{
                lang: 'en'
            }}
            // link={favIconTag}
            title={title}
            titleTemplate={`%s | ${site.title}`}
            meta={metaTags}
            script={scripts}
        >
            <link
                rel="icon"
                // We get a url for this via graphql because we don't want to
                // inline it, which webpack would do for us if we imported it
                // directly
                // Querying publicURL on a file node causes it to be copied
                href={staticFileUrls.get(FAVICON)}
                type="image/svg+xml"
                sizes="any"
            />
            {children}
        </Helmet>
    )
}


export default Seo
